import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BdvAsyncManagementService {
  
  private readonly bdvApiUrl = environment.BASE_BDV_API;
  
  constructor(private readonly http: HttpClient) {}

  public getAsyncStatus(): Observable<any> {
    return this.http.get(`${this.bdvApiUrl}/api/config/async-verification`);
  }

  public toggleAsync(enabled: boolean): Observable<any> {
    return this.http.put(`${this.bdvApiUrl}/api/config/async-verification`, { enabled });
  }

  getAllConfigs(): Observable<any> {
    return this.http.get(`${this.bdvApiUrl}/api/config/all`);
  }

  getHealth(): Observable<any> {
    return this.http.get(`${this.bdvApiUrl}/api/config/health`);
  }

  reloadCache(): Observable<any> {
    return this.http.post(`${this.bdvApiUrl}/api/config/reload`, {});
  }

  updateConfig(configKey: string, value: any): Observable<any> {
    return this.http.put(`${this.bdvApiUrl}/api/config/${configKey}`, { value });
  }
}
